import { API_URLS } from '@bg-shared/constants/apiUrls';
import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { BALANCE_UPDATE } from '@bg-shared/constants/socketChannels';
import { requestInterval, visibility } from '@betgames/bg-tools';
import { BALANCE_REFRESH_INTERVAL } from '@bg-shared/constants/constants';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { webAPIIntegration } from '@bg-shared/integrations/WebIntegration/webAPIIntegration';
import { getMatchedGameId } from '@bg-shared/utils/getMatchedGameId';
import { ClassicGameDefinition } from '@bg-shared/utils/ClassicGameDefinition';
import { stagedBetsApi } from '@bg-shared/business/StagedBets';
import { IStagedBetsResponseData } from '@bg-shared/business/CasinoBetting/interfaces';
import { balanceStore } from './Balance.store';
import { IBalanceState } from './interfaces';

export default class BalanceService {
    private events: Array<() => void> = [];

    public ping(): Promise<string> {
        let params = null;
        const gameId = getMatchedGameId(window.location.pathname);

        if (partnerSettingsStore.isApiSendBalancePerGame && gameId) {
            params = { gameId };
        }

        return httpClientRepository
            .get<{ value: string }>(API_URLS.GET_BALANCE, {
                params,
                transformRequest: false,
            })
            .then((balance) => {
                balanceStore.updateBalanceStore({ balance: balance.value });
                return balance.value;
            })
            .catch((error) => {
                console.error('Ping balance error', error?.message);
                return null;
            });
    }

    public runEvents(): void {
        this.ping();

        this.events.push(
            ...[
                webSocketsRepository.on<IBalanceState>(BALANCE_UPDATE, (response) => {
                    webAPIIntegration(partnerSettingsStore.webIntegrationType, (api) => {
                        api.balanceUpdate(response.balance);
                    });
                    balanceStore.updateBalanceStore(response);
                }),

                requestInterval(() => {
                    this.ping();
                }, BALANCE_REFRESH_INTERVAL),

                visibility.setEvent((hidden) => {
                    if (!hidden) {
                        this.ping();
                    }
                }),
            ],
        );
    }

    public stopEvents(): void {
        this.events.forEach((unsubscribe) => {
            unsubscribe();
        });
        this.events = [];
    }

    public getTotalStagedBetsAmount(): Promise<IStagedBetsResponseData> {
        return stagedBetsApi
            .getStagedBets(ClassicGameDefinition.GAMES_WITH_CHIPS)
            .then((response) => {
                if (!response.data.length) {
                    return [];
                }

                return response.data;
            });
    }
}

export const balanceService = new BalanceService();
